var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Função ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da função*",
      "counter": "32",
      "maxlength": "32",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 32);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" Tipo do Profissional* "), _c('v-radio-group', {
    attrs: {
      "rules": [function (v) {
        return v !== null || 'Campo obrigatório';
      }],
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.servidorDoEstado,
      callback: function ($$v) {
        _vm.$set(_vm.content, "servidorDoEstado", $$v);
      },
      expression: "content.servidorDoEstado"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Servidor do Estado de PE",
      "value": true
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Profissional externo",
      "value": false
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Atividades",
      "outlined": "",
      "dense": "",
      "rows": "4",
      "maxlength": "2500",
      "counter": ""
    },
    model: {
      value: _vm.content.atividades,
      callback: function ($$v) {
        _vm.$set(_vm.content, "atividades", $$v);
      },
      expression: "content.atividades"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios")])], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }